import React, { useState, useEffect } from 'react';
import {
  Empty, Col, Row, Space, Button, Tooltip
} from 'antd';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Auth } from 'aws-amplify';
import RecipeDetails from 'containers/computers/recipes/details/Details';
import SpecificationFlow from 'containers/specifications/generationFlow';

const RecipeResult = (props) => {
  const { location: { state }, history: { replace, push } } = props;
  const [specifications, setSpecifications] = useState(false);
  const [userIsAuth, setUserIsAuth] = useState(false);

  useEffect(() => {
    Auth.currentCredentials().then(cred => setUserIsAuth(cred?.authenticated));
  }, []);

  const handleSaveRecipe = () => {
    if (userIsAuth) {
      return replace({
        pathname: '/recipes',
        state: { recipe: state.recipe }
      });
    }
    return push({
      pathname: '/authForm',
      state: { recipe: state.recipe }
    });
  };

  const handleGenerateSpecifications = () => {
    setSpecifications(true);
  };

  const renderContent = () => {
    if (_.isEmpty(state)) {
      return <Empty />;
    }
    return (
      <>
        {specifications && (
          <>
            <SpecificationFlow recipe={state.recipe} setSpecifications={setSpecifications} />
          </>
        )}
        {!specifications && (
          <>
            <RecipeDetails recipeFromProps={state.recipe} {...props} />
            <Row justify="center">
              <Space wrap align="start" size="large" style={{ marginTop: '20px' }}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Tooltip title="Confidentialité garantie">
                    <Button type="primary" onClick={() => handleSaveRecipe()}>Enregistrer ma recette</Button>
                  </Tooltip>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Tooltip title="Confidentialité garantie">
                    <Button type="primary" onClick={() => handleGenerateSpecifications()}>Générer le cahier des charges</Button>
                  </Tooltip>
                </Col>
              </Space>
            </Row>
          </>
        )}
      </>
    );
  };
  return (
    renderContent()
  );
};

RecipeResult.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      recipe: PropTypes.shape({
        name: PropTypes.string,
        ingredient: PropTypes.arrayOf(PropTypes.shape({
          ingredient: PropTypes.string,
          themes: PropTypes.string,
          condition: PropTypes.string,
        }))
      })
    })
  }),
  history: PropTypes.shape({
    replace: PropTypes.func
  })
};

export default RecipeResult;
